<template>
  <div
    class="custom-modal"
    v-if="isOpen"
    :class="{ 'custom-modal--open': isOpen }"
  >
    <div class="custom-modal__background" @click="close"></div>
    <div class="custom-modal__window">
      <!-- <div class='custom-modal__window-wrapper'>
				<div class='custom-modal__header'>
					<span>{{ title }}</span>
					<button class='custom-modal__close-btn' @click='close'><i class='fa fa-times'></i></button>
				</div>
				<div class='custom-modal__body'>
					<slot name='default'></slot>
				</div>
			</div> -->

      <div class="custom-modal__header">
        <span class="custom-modal__title"><b>Ведомость</b> {{ title }}</span>
        <button class="custom-modal__close-btn" @click="close">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="custom-modal__body">
        <slot name="default"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomModal",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      console.log("close");
      this.isOpen = false;
    },
  },
};
</script>

<style scoped>
.custom-modal {
  height: 100vh;
  width: 100vw;

  position: fixed;
  top: 0;
  left: 0;

  z-index: 100;
}

.custom-modal__background {
  height: 100%;
  width: 100%;

  background-color: rgba(0, 0, 0, 0.5);
  transition: all 1s ease;
}

.custom-modal__window {
  background-color: #fff;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  height: 90%;
  width: 90%;
  min-width: 800px;
  max-width: 1400px;

  padding: 10px 0;
}

/*.custom-modal__window-wrapper {
		padding: 20px;
		height: 100%;
	}*/

.custom-modal__header {
  height: 2rem;
}

.custom-modal__body {
  overflow-y: auto;
  /*overflow-y: hidden;*/
  height: calc(100% - 2rem);
  /*margin: 0 10px;*/
  padding: 0 10px;
}

.custom-modal__title {
  padding: 10px;
  font-size: 20px;
}

.custom-modal__close-btn {
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;

  border: none;
  background-color: inherit;
  outline: none;

  font-size: 20px;

  transition: 0.2s all ease;
}

.custom-modal__close-btn:hover {
  /*font-size: 24px;*/
  color: gray;
}
</style>
